"use client";
import AccountStatus from "@/functions/Cookies/Cookies";
import { logoutReducer } from "@/redux/Slices/accountSlice";
import { displayWishlist } from "@/redux/Slices/wishListSlice";
import { message } from "antd";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { useDispatch } from "react-redux";

const Wishlist = ({ productId }) => {
  const { loggedIn, comverse_customer_token } = AccountStatus();
  const dispatch = useDispatch();
  const [productInWishList, setProductInWishList] = useState(false);
  const [loading, setLoading] = useState(false);

  const getStoreId = () => Cookies.get("fashionCurrencyId") || "23";

  const addProductToWishlist = async () => {
    if (!loggedIn || !comverse_customer_token) {
      message.error("Login to add to wishlist");
      return;
    }
    try {
      setLoading(true);
      const headers = {
        "Content-Type": "application/json",
      };
      if (comverse_customer_token) {
        headers.Authorization = comverse_customer_token;
      }

      const body = {
        storefront: getStoreId(),
        product_ids: [productId], // product detail id,
      };

      const payload = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body),
      };

      const res = await fetch(
        process.env.NEXT_PUBLIC_BACKEND + "/storefront/add_product_to_wishlist",
        payload,
      );
      const data = await res.json();

      if (!res.ok) {
        // message.error("Failed to add in Wishlist!");
        throw new Error("Api Failed!");
      } else {
        message.success("Product Added to Wishlist!");
        setProductInWishList(true);
        dispatch(displayWishlist(true));
        setLoading(false);
        const itemsData = data?.map((item) => ({
          item_id: item?.id ?? null,
          item_name: item?.title,
          item_variant: item?.variants[0]?.id,
          item_brand: item?.brand[0]?.title,
          price: item?.variants[0]?.variant_detail?.discounted_price,
          location_id: defaultgeoLocationCountry,
        }));

        return data;
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const getWishlist = async () => {
    if (!loggedIn || !comverse_customer_token) {
      return;
    }

    setLoading(true);
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      if (comverse_customer_token) {
        headers.Authorization = comverse_customer_token;
      }

      const payload = {
        method: "GET",
        headers: headers,
      };

      const res = await fetch(
        process.env.NEXT_PUBLIC_BACKEND +
          `/storefront/wishlist_list?storefront=${getStoreId()}`,
        payload,
      );
      const data = await res.json();

      if (!res.ok) {
        // message.error("Failed to get Wishlist!");
        if (data?.detail === "Invalid auth token") {
          dispatch(logoutReducer());
        }
        throw new Error("Api Failed!");
      } else {
        const found = data.results?.find(
          (wishListItem) => wishListItem?.id === productId,
        );
        if (found) {
          setProductInWishList(true);
        }
        setLoading(false);
        return data;
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const removeProductFromWishlist = async () => {
    if (!loggedIn || !comverse_customer_token) {
      message.error("Login in to remove from wishlist");
      return;
    }
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      if (comverse_customer_token) {
        headers.Authorization = comverse_customer_token;
      }

      const body = {
        storefront: getStoreId(),
      };

      const payload = {
        method: "DELETE",
        headers: headers,
        body: JSON.stringify(body),
      };

      const res = await fetch(
        process.env.NEXT_PUBLIC_BACKEND +
          `/storefront/remove_product_from_wishlist?product_id=${productId}`,
        payload,
      );
      const data = await res.json();

      if (!res.ok) {
        // message.error("Failed to delete from Wishlist!");
        throw new Error("Api Failed!");
      } else {
        setProductInWishList(false);
        message.success("Product Deleted from Wishlist!");
        return data;
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getWishlist();
  }, []);

  return (
    <span
      onClick={
        productInWishList ? removeProductFromWishlist : addProductToWishlist
      }
      style={{
        cursor: loading ? "not-allowed" : "pointer",
      }}
    >
      {productInWishList ? (
        <FaHeart size={18} color="#EE3C24" />
      ) : (
        <FaRegHeart size={18} color="#333333" />
      )}
    </span>
  );
};

export default Wishlist;
